const Loader = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 120 119"
            {...props}
        >
            <path
                fill="#60AA9F"
                d="M67.11 53.6a20.82 20.82 0 01-8.65 5.76 30.77 30.77 0 005.91-6.82c2.94-4.89 2.17-9.41.42-11.72-3-4-8.23-5.89-12.65-10.44-4.71-4.83-4.09-11.25-.42-16 2.56-3.31 9.48-6.6 9.48-6.6a44.404 44.404 0 00-5.69 7.45c-2.15 3.85-2.49 7.87.42 10.87 3.21 3.3 9.25 5.92 12.23 10.44 3.16 4.78 4.58 10.31-1.05 17v.06zm-19 8.68c.34-8.78 9.17-10.71 8.65-16-.51-5.11-7.59-9.37-7.59-9.37s11.63 1.84 11.38 10c-.23 7.6-9.35 10.44-9.06 16 .36 6.94 7.8 10 7.8 10s-11.51-1.86-11.18-10.65v.02zm70.95-2.73a59.53 59.53 0 10-67.67 58.951c0-1.62-.07-3.41-.07-5a5.106 5.106 0 00-2.15-4.4c-2.54-1.46-1.37-4.78-.58-5.76.79-.98.29-2.93.29-2.93-6.83-3-6.35-8.69-6.35-8.69v-8c-3.41 0-2.93-2.84-1.17-2.84h36.33c1.76 0 2.26 2.84-1.17 2.84v8s.49 5.66-6.34 8.69c0 0-.49 1.95.29 2.93.78.98 2 4.3-.59 5.76a5.11 5.11 0 00-2.15 4.4c0 1.59-.12 3.38-.06 5a59.54 59.54 0 0051.39-59"
            />
        </svg>
    )
}

export default Loader
